import "devise.scss";
import("bootstrap");
import $ from "jquery";
import debounce from "../src/lib/debounce";
import "./password-reveal.js";

$(() => {
  $("#registration_nickname").each((_index, el) => {
    const $nickname = $(el);
    const $form = $nickname.closest("form");
    const $submit = $form.find("input[type=submit]:first");
    const $feedback = $("<div></div>").hide().insertAfter($nickname);
    const token = $("#registration_token").attr("value");

    const disableSubmit = () => {
      $submit.attr("disabled", true);
    };

    const enableSubmit = () => {
      $submit.attr("disabled", false);
    };

    const markValid = (message) => {
      $nickname.addClass("is-valid").removeClass("is-invalid");
      $feedback
        .addClass("valid-feedback")
        .removeClass("invalid-feedback")
        .text(message)
        .show();
      enableSubmit();
    };

    const markInvalid = (message) => {
      $nickname.addClass("is-invalid").removeClass("is-valid");
      $feedback
        .removeClass("valid-feedback")
        .addClass("invalid-feedback")
        .text(message)
        .show();
      disableSubmit();
    };

    const checkIfTaken = (event) => {
      let nickname = event.target.value;
      $.getJSON("/registrieren/express/nickname", {
        q: nickname,
        token: token,
      }).then(({ valid, message }) => {
        if (valid) {
          markValid(message);
        } else {
          markInvalid(message);
        }
      });
    };
    $nickname.on("keyup", debounce(250, checkIfTaken));
    $nickname.on("keyup", disableSubmit);

    if ($nickname.attr("value").startsWith("KT-")) {
      $nickname.select();
    }
  });

  // Show spinner on button click
  $("button#oauth-signin, button#password-signin").each(function () {
    const $button = $(this);
    const disable_with = $button.data("disable-with") || "";

    $button.on("click", function (_event) {
      if (disable_with.length > 0) {
        $button.find(".label").text(disable_with);
      }
      $button.prop("disabled", true).addClass("logging-in");
      $button.closest("form").submit();
    });
  });

  // Automatic sign in
  $("button#oauth-signin").each(function () {
    const $button = $(this);
    const wait = $button.data("wait") || 50;

    setTimeout(() => {
      $button.click();
    }, wait);
  });

  $("input#iframe").each(function () {
    const $iframe = $(this);
    const value = $iframe.attr("value") || "";
    if (value.length > 0) {
      window.parent.postMessage(
        {
          type: "ma_session",
          action: "new",
          height: $(document.body).height(),
        },
        "*",
      );
      $("form#new_user").on("focus", "input", function () {
        window.parent.postMessage({ type: "ma_session", action: "keep" }, "*");
      });
    }
  });
});
